import { CustomerGender } from '../types';
import { useFetchRecommendations } from './use-fetch-recommendations';
export var useRecommendations = function (gender) {
    // TODO: Right now, we are calling both recommendations in sequential order, we need to improve this to call them paralle.
    var _a = useFetchRecommendations(CustomerGender.MALE), recomendationsMale = _a[0], loadingMale = _a[1];
    var _b = useFetchRecommendations(CustomerGender.FEMALE), recomendationsFemale = _b[0], loadingFemale = _b[1];
    if (gender === CustomerGender.MALE) {
        if (Array.isArray(recomendationsMale)) {
            return [recomendationsMale, loadingMale];
        }
        return [[], loadingMale];
    }
    if (Array.isArray(recomendationsFemale)) {
        return [recomendationsFemale, loadingFemale];
    }
    return [[], loadingFemale];
};
